import { inject } from "fw";
import { DialogService } from "fw-dialog";

import { PopoverService } from "service/popover";

import { ConfirmDialog, ConfirmDialogArgs } from "views/components/confirm-dialog";
import { ConfirmDialogV2, ConfirmDialogV2Args } from "views/components/confirm-dialog-v2";
import { SystemMessageDialog, SystemMessageDialogArgs } from "views/components/system-message";


@inject
export class Confirm {
  constructor(private dialogService: DialogService, private popoverService: PopoverService) { }

  async confirmV2(
    text: string,
    args: { title?: string, okButtonText?: string, cancelButtonText?: string; okButtonClass?: string } = {},
    asPopover = false,
  ) {
    const { title, cancelButtonText, okButtonClass, okButtonText } = args;
    const confirmArgs: ConfirmDialogV2Args = {
      text,
      title,
      cancelButtonText,
      okButtonClass,
      okButtonText,
    };

    const result = asPopover ?
      await this.popoverService.open<void>(ConfirmDialogV2, confirmArgs) :
      await this.dialogService.open<void>(ConfirmDialogV2, confirmArgs, { cssClass: "confirmation-dialog-v2" });

    return !result.canceled;
  }

  async confirm(text: string, args: { okButtonText?: string, cancelButtonText?: string; okButtonClass?: string } = {}, asPopover = false) {
    const { cancelButtonText, okButtonClass, okButtonText } = args;
    const confirmArgs: ConfirmDialogArgs = {
      text,
      cancelButtonText,
      okButtonClass,
      okButtonText,
    };

    const result = asPopover ?
      await this.popoverService.open<void>(ConfirmDialog, confirmArgs) :
      await this.dialogService.open<void>(ConfirmDialog, confirmArgs, { cssClass: "confirmation-dialog" });

    return !result.canceled;
  }

  async confirmDelete(text: string, deleteButtonText = "Delete" , cancelButtonText = "Keep") {
    return await this.confirm(text, { okButtonText: deleteButtonText, cancelButtonText, okButtonClass: "alert" });
  }

  async systemMessage(text: string, okButtonText = "OK", infos: string[] = null) {
    const result = await this.dialogService.open<void>(SystemMessageDialog, { text, infos, okButtonText }, { cssClass: "confirmation-dialog" });
    return !result.canceled;
  }
}
